import { render, staticRenderFns } from "./IpBundleLists.vue?vue&type=template&id=46d7dde8&scoped=true&"
import script from "./IpBundleLists.vue?vue&type=script&lang=js&"
export * from "./IpBundleLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d7dde8",
  null
  
)

export default component.exports